import {apiSlice} from './apiSlice';

/**
 * Endpoints module PageSpeed / Core Web Vitals.
 *
 * - analyzePsi: gửi url, BE gọi PageSpeed Insights (mobile + desktop) + parse + lưu,
 *   trả kết quả đầy đủ. Mutation (tạo bản ghi) → invalidate 'PsiReport'.
 * - getPsiReports / getPsiReport: lịch sử + chi tiết 1 báo cáo.
 * - deletePsiReport: xoá 1 báo cáo.
 */
export const pagespeedApiSlice = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		analyzePsi: builder.mutation({
			query: (url) => ({url: 'pagespeed/analyze', method: 'post', data: {url}}),
			transformResponse: (body) => body?.data || null,
			invalidatesTags: ['PsiReport'],
		}),
		getPsiReports: builder.query({
			query: (keyword = '') => ({
				url: 'pagespeed',
				method: 'get',
				...(keyword ? {params: {keyword}} : {}),
			}),
			transformResponse: (body) => body?.data || [],
			providesTags: ['PsiReport'],
		}),
		getPsiReport: builder.query({
			query: (id) => ({url: `pagespeed/${id}`, method: 'get'}),
			transformResponse: (body) => body?.data || null,
			providesTags: (result, error, id) => [{type: 'PsiReport', id}],
		}),
		deletePsiReport: builder.mutation({
			query: (id) => ({url: `pagespeed/${id}`, method: 'delete'}),
			invalidatesTags: ['PsiReport'],
		}),
	}),
});

export const {
	useAnalyzePsiMutation,
	useGetPsiReportsQuery,
	useGetPsiReportQuery,
	useDeletePsiReportMutation,
} = pagespeedApiSlice;
